import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { AdminLayout } from "@/admin/AdminLayout";
import { getStoreByIdFn } from "@/server-fns/admin/storeFns";

export const Route = createFileRoute("/app/$storeId")({
    head: () => ({
        meta: [{ name: "robots", content: "noindex, nofollow" }],
    }),
    beforeLoad: async ({ params }) => {
        const result = await getStoreByIdFn({ data: { storeId: params.storeId } });
        if (result.status === "unauthenticated") {
            throw redirect({ to: "/signin" });
        }
        if (result.status === "not-found" || !result.store) {
            throw redirect({ to: "/app" });
        }
        return { store: result.store };
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { store } = Route.useRouteContext();
    return (
        <AdminLayout store={store}>
            <Outlet />
        </AdminLayout>
    );
}
